export default __webpack_public_path__ + "static/media/clawfx.2cb23486.mp3";